<template>
  <div
    :class="['theme-checkbox__field-holder',
    {
      'theme-checkbox__field-holder--error': !!errors.has(newName),
    }]"
    data-vv-value-path='model'
    :data-vv-as='label ? label : labelHtml'
  >
    <label class='theme-input__label' v-if='labelHtml' v-html='labelHtml'></label>
    <label class='theme-input__label mb-4' v-if='label && !labelHtml && !hideLabel'>
      {{ label }}
      <span v-if='isRequired' class='theme-input__label-asterisk'>*</span>
    </label>
    <input
      v-if='setForm'
      type='hidden'
      :form='form'
      :name='`hidden_` + name'
      v-model='model'
      v-validate='rules'
    />
    <input
      v-else
      type='hidden'
      :name='`hidden_` + name'
      v-model='model'
      v-validate='rules'
    />
    <div
      :class="['theme-checkbox',
      {
        'theme-checkbox--is-dirty': isDirty,
        'theme-checkbox--is-disabled': disabled,
        'theme-checkbox--has-label': Object.keys(options).length || this.$slots.default,
        'theme-checkbox--column-direction': columnDirection
      }]"
    >
      <template v-if='Object.keys(options).length'>
        <label
          :class="['theme-checkbox__item',
          {
            'theme-checkbox__item--disabled': disabled,
            'theme-checkbox__item--bold-label': boldLabel,
          }]"
          v-for='(option, key) in options'
          :key='key'
        >
          <input
            v-if='isSingleCheckbox && setForm'
            :name='name'
            :form='form'
            type='checkbox'
            :value='key'
            :true-value='1'
            :false-value='0'
            v-model='model'
            :disabled='disabled'
            :id='id'
            @change='stateChange(model)'
          />
          <input
            v-else-if='isSingleCheckbox'
            :name='name'
            type='checkbox'
            :value='key'
            :true-value='1'
            :false-value='0'
            v-model='model'
            :disabled='disabled'
            :id='id'
            @change='stateChange(model)'
          />
          <input
            v-else-if='setForm'
            :name='name'
            :form='form'
            type='checkbox'
            :value='key'
            true-value='yes'
            false-value='no'
            v-model='model'
            :disabled='disabled'
            :id='id'
            @change='stateChange(model)'
          />
          <input
            v-else
            :name='name'
            type='checkbox'
            :value='key'
            true-value='yes'
            false-value='no'
            v-model='model'
            :disabled='disabled'
            :id='id'
            @change='stateChange(model)'
          />
          <div class='theme-checkbox__indicator'></div>
          <template v-if='option'>
            <span class='theme-checkbox__item-label' :class="{ 'theme-checkbox__big-label': bigLabel }" v-html='option'></span>
          </template>
        </label>
      </template>
      <label v-else class='theme-checkbox__item'>
        <input
          :name='name'
          type='checkbox'
          v-model='model'
          :disabled='disabled'
          @change='
            // disableAutoComplete();
            stateChange(model);'
        />
        <div class='theme-checkbox__indicator'></div>
        <span class='theme-checkbox__item-label'>
          <template>
            <slot></slot>
          </template>
        </span>
      </label>
    </div>
    <div v-if='additionalHtml' class='theme-checkbox__note registration-form-layout__note' v-html='additionalHtml'></div>
  </div>
</template>

<script>
  import field from '../admin/mixins/field';

  export default {
    computed: {
      isDirty() {
        return !!this.model;
      },
    },
    data() {
      return {
        model: this.isSingleCheckbox ?
          (this.value === 1 || this.value === '1' ? 1 : 0) :
          (this.hasMultipleValues ? this.value : (this.value ? [this.value] : this.values)),
      };
    },
    mixins: [field],
    watch: {
      value(newVal) {
        if (this.isSingleCheckbox) {
          this.model = (newVal === 1 || newVal === '1') ? 1 : 0;
        }
      },
    },
    methods: {
      stateChange(model) {
        this.$emit('changed', model);
      },
      // disableAutoComplete() {
      //   let elements = document.querySelectorAll('[autocomplete="off"]');

      //   if (!elements) {
      //     return;
      //   }

      //   [...elements].forEach(element => {
      //     element.setAttribute('readonly', 'readonly');

      //     setTimeout(() => {
      //       element.removeAttribute('readonly');
      //     }, 500);
      //   });
      // }
    },
    props: {
      label: {
        default() {
          return '';
        },
        type: String,
      },
      options: {
        default: () => { return {}; },
        type: [Object, Array],
      },
      values: {
        default: () => { return []; },
        type: Array,
      },
      value: {
        default: '',
        type: [Number, String, Array],
      },
      labelHtml: {
        default() {
          return '';
        },
        type: String,
      },
      extraStylingIsEnabled: {
        default: false,
        type: Boolean,
      },
      setForm: {
        default: false,
        type: Boolean,
      },
      form: {
        default() {
          return '';
        },
        type: String,
      },
      id: {
        default: '',
        type: String,
      },
      isSingleCheckbox: {
        default: false,
        type: Boolean,
      },
      hasMultipleValues: {
        default: false,
        type: Boolean,
      },
      additionalHtml: {
        default: '',
        type: String,
      },
      bigLabel: {
        default: false,
        type: Boolean,
      },
      isRequired: {
        default: false,
        type: Boolean,
      },
      boldLabel: {
        default: false,
        type: Boolean,
      },
      columnDirection: {
        default: false,
        type: Boolean,
      },
      hideLabel: {
        default: false,
        type: Boolean,
      },
    },
  };
</script>